export default {
  title: "Contact"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5009: { text: "Ocurrió un error en el catálogo de Contact" }
    , WS5009: { text: "Ocurrió un error en el catálogo de Contact" }
    , JS5009: { text: "Ocurrió un error en el catálogo de Contact" }
    , CR5009: { text: "Ocurrió un error en el catálogo de Contact" }
    , UK_Contact: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/contact.js